var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1373e6;}.b{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3148.154,6709.95l3.933,3.732,6.484-6.974",
    transform: "translate(-3145.654 -6702.209)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxActive);
export default __webpack_public_path__ + "static/media/checkbox_active.d4c815cd209ea0130e31c2129c4bc063.svg";
export { ForwardRef as ReactComponent };